import { FC, PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';
import { useOrientationClassName } from './hooks/useOrientationClassName';
import { GPTGameObjectType } from '../../types';

type ModalWrapperProps = {
  orientation: GPTGameObjectType['orientation'];
};

export const ModalWrapper: FC<PropsWithChildren<ModalWrapperProps>> = ({
  children,
  orientation
}) => {
  const classNameFromOrientation = useOrientationClassName(orientation);

  return (
    <div className={twJoin('relative overflow-hidden', classNameFromOrientation)}>{children}</div>
  );
};
